(() => {
  const page = document.querySelector('[data-story-page]');
  if (!page) return;

  const revealItems = page.querySelectorAll('.story-reveal');
  if (!revealItems.length) return;

  const observer = new IntersectionObserver(
    (entries, io) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -100px 0px',
      threshold: 0.15,
    }
  );

  revealItems.forEach((item) => observer.observe(item));
})();
